import Vue from 'vue'
import App from './App.vue'
import './plugins/axios'
import router from './router'
import Moment from 'moment'
// import BScroll from 'better-scroll'
import './assets/font/iconfont.css'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import "./plugins/vant.js"

// import 'lib-flexible'
// import scroll from 'vue-seamless-scroll'
// import VueClipboard from 'vue-clipboard2'

let wrapper = document.querySelector('.wrapper')
    // let scroll = new BScroll(wrapper, {})
    // Vue.use(VueClipboard)
Vue.prototype.$moment = Moment; //赋值使用
Vue.prototype.$ishttps = localStorage.getItem('ishttps')

// Vue.use(scroll)
// 定义全局时间戳过滤器
Vue.filter('formatDate', function(value) {
    return Moment(value).format('YYYY-MM-DD HH:mm:ss')
})


// 自定义获取cooke的函数
Vue.prototype.$getCooke = function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i].trim();
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return "";
}


let options = {
    fullscreenEl: false
};

Vue.use(preview, options)
Vue.use(preview)
Vue.use(ElementUI);

router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
})


Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')